<template>
  <section style="height: 100%">
    <div class="container">
      <el-aside style="padding-right: 20px;border-right:1px solid #e9eaf2;width: 150px;">
        <h1>账号状态</h1>
        <el-tree
          style="margin-top: 10px;margin-bottom:10px;"
          :data="status"
          node-key="id"
          icon-class="el-icon-s-flag"
          default-expand-all
          :expand-on-click-node="false"
          :highlight-current="true"
          :current-node-key="treeCurrentNode"
        >
          <span
            class="custom-tree-node"
            slot-scope="{ node, data }"
            @click="showTreeWorker(data.id, data.pid)"
          >
            <span>
              {{ data.label }}
            </span>
          </span>
        </el-tree>
      </el-aside>
      <el-main style="width: 100%;box-sizing: border-box;padding-left:20px;">
        <div
          class="worker-tooltips"
          style="display:flex;flex-wrap:wrap; width: 100%;justify-content: flex-start"
        >
          <div class="search-box"><h1>内容账号</h1></div>
          <div class="control-box" style="margin-top: 10px;" v-if="admin_permission.indexOf('look')>-1 || admin_permission.indexOf('add')>-1">
            <el-select v-model="params.province_id" placeholder="请选择省份" clearable @change="provinceClick()">
              <el-option
                v-for="item in provinceList"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
            <el-select v-model="params.city_id" placeholder="请选择市" clearable style="margin-left:10px;" @change="cityClick()">
              <el-option
                v-for="item in cityList"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
            <el-select v-model="params.area_id" placeholder="请选择地区" clearable style="margin-left:10px;" @change="areaClick()">
              <el-option
                v-for="item in areaList"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
            <el-time-select
              placeholder="起始时间"
              v-model="params.startTime"
              style="margin-left:10px;"
              :picker-options="{
                start: '06:30',
                step: '00:15',
                end: '22:30'
              }">
            </el-time-select>
            <el-time-select
              placeholder="结束时间"
              style="margin-left:10px;"
              v-model="params.endTime"
              :picker-options="{
                start: '06:30',
                step: '00:15',
                end: '22:30',
                minTime: params.startTime
              }">
            </el-time-select>
            <el-button icon="el-icon-search" @click="getTableData" style="margin-left:10px;">搜索</el-button>
            <el-button icon="el-icon-plus" type="primary" @click="handleOpenAdd" v-if="admin_permission.indexOf('add')>-1">添加内容</el-button>
          </div>
        </div>
        <div class="table">
          <el-row :gutter="5" style="width: 100%;">
            <el-col :xs="12" :sm="8" :md="6" :lg="4" :xl="4" v-for="(value,key) in table" style="margin-bottom:10px;">
              <el-card :body-style="{ padding: '0px' }" style="position: relative;">
                <img :src="value.src" style="width: 100%;">
                <el-tag type="" style="position:absolute;top:0;right:0" size="mini" effect="dark" v-if="value.status===0">审核中</el-tag>
                <el-tag type="success" style="position:absolute;top:0;right:0" size="mini" effect="dark" v-if="value.status===1">审核通过</el-tag>
                <el-tag type="info" style="position:absolute;top:0;right:0" size="mini" effect="dark" v-if="value.status===2">不通过</el-tag>
                <div style="padding: 2px 8px; position: relative;">
                  <div style="font-weight:bold;font-size:14px;width: 100%;">
                    {{value.name}}
                  </div>
                  <div style="font-size: 12px;width: 100%;margin-top:5px;">
                    区域: {{value.province_name}} {{value.city_name}} {{value.area_name}}
                  </div>
                  <div style="font-size: 12px;width: 100%;margin-top:2px;">
                    时间段: {{value.start_time}} 至 {{value.end_time}}
                  </div>
                  <div class="bottom clearfix" style="position: absolute;top:0px;right:5px;">
                    <el-dropdown @command="command($event,value.id)">
                      <span class="el-dropdown-link" style="color: #409EFF">
                        操作<i class="el-icon-arrow-down el-icon--right"></i>
                      </span>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="edit">修改</el-dropdown-item>
                        <el-dropdown-item command="apply" devided :disabled="value.status!==0">审核通过</el-dropdown-item>
                        <el-dropdown-item command="refuse" :disabled="value.status!==0">审核失败</el-dropdown-item>
                        <el-dropdown-item command="delete" devided>删除</el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </div>
                </div>
              </el-card>
            </el-col>
            
          </el-row>
          
        </div>
        
        <div style="width:100%;display:flex;justify-content: flex-end;box-sizing: border-box;padding: 10px;">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page.sync="params.page"
            :hide-on-single-page="false"
            :small="true"
            :page-size="params.page_count"
            layout="total, prev, pager, next"
            :total="total">
          </el-pagination>
        </div>
      </el-main>
    </div>

    <el-drawer
      title="更改媒体内容"
      :visible.sync="editDrawer"
      :direction="direction"
      :before-close="handleClose"
    >
      <edit-comp v-if="editDrawer" @close="handleClose" @success="handleDrawerSuccess" :id="editID" ref="newForm"></edit-comp>
    </el-drawer>

    <!-- 添加规则 -->
    <el-drawer
      title="添加媒体内容"
      :visible.sync="addDrawer"
      :direction="direction"
      :before-close="handleClose"
    >
      <add-comp
        @close="handleClose"
        @success="handleDrawerSuccess"
        @clear="clearContent"
        ref="newForm"
        v-if="addDrawer"
      ></add-comp>
    </el-drawer>
  </section>
</template>

<script>
  import { getList, addData,updateData,apply,refuse} from "@/api/media.js";

  import { getProvince,getCity,getArea} from "@/api/public.js";
  import addComp from "./components/add.vue";
  import editComp from "./components/edit.vue";

  let page_name = 'media_management'
  export default {
    name: "App",
    components:{addComp,editComp},
    data() {
      return {
        admin_permission:[],
        status: [
          {id:"",label:"全部"},
          {id:0,label:"审核中"},
          {id:1,label:"审核通过"},
          {id:2,label:"审核拒绝"},
        ],
        treeCurrentNode:"",
        provinceList:[],
        cityList:[],
        areaList:[],
        province_id:"",
        city_id:"",
        params: {
          page: 1,
          page_count: 10,
          province_id:'',
          city_id:'',
          area_id:'',
          startTime: '',
          endTime: '',
        },

        table:[],

        service: [],
        editID: '',
        total: 0,
        outerVisible: false,
        innerVisible: false,
        addDrawer: false,
        editDrawer: false,
        direction: "rtl",
        addTradeParams: {
          name: "",
          parent_id: 0
        },
        visible: false,
        scopeForm:{
          id:'',
          sort: ''
        }
      };
    },

    methods: {
      getTableData() {
        getList(this.params).then(res=>{
          if(res.code === 200){
            this.table = res.data.data
            this.params.page = res.data.current_page
            this.params.page_count = res.data.per_page
            this.total = res.data.total
          }
        })
      },

      provinceClick(){
        let that = this
        this.provinceList.forEach(item => {
          if(item.id == that.params.province_id ){
            that.province_id = item.province_id
            console.log(that.province_id)
          }
        });
        getCity(that.province_id).then(res=>{
          if(res.code === 200){
            console.log(res.data)
            this.cityList = res.data
          }
        })
      },
      cityClick(){
        let that = this
        this.cityList.forEach(item => {
          if(item.id == that.params.city_id ){
            that.city_id = item.city_id
            console.log(that.city_id)
          }
        });
        getArea(that.city_id).then(res=>{
          if(res.code === 200){
            console.log(res.data)
            this.areaList = res.data
          }
        })
      },
      command(e,id){
        console.log(31431)
        if(e === 'edit'){
          this.editTable(id)
        }
        if(e === 'apply'){
          this.$confirm('此操作将审核通过, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            apply(id).then(res=>{
              if(res.code === 200){
                this.$message({
                  message: "操作成功",
                  type: "success"
                });
                this.getTableData();
              }
            })
          }).catch(() => {
          });
        }
        if(e === 'refuse'){
          this.$confirm('此操作将审核失败, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            refuse(id).then(res=>{
              if(res.code === 200){
                this.$message({
                  message: "操作成功",
                  type: "success"
                });
                this.getTableData();
              }
            })
          }).catch(() => {
          });
        }
        if(e === 'delete'){
          this.$confirm('此操作将拉黑此账号, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            
          }).catch(() => {
          });
        }
      },

      writeScope(id){
        console.log(id)
        this.scopeForm.id = id
        let tmp = [];
        this.service.forEach((value,key)=>{
          tmp[key] = value
          if (id === value.id){
            this.scopeForm.sort = parseInt(value.sort)
            tmp[key].write_scope = true
          }
        })
        this.service = tmp;
      },

      scopeChange(){
        editData(this.scopeForm.id,{sort:this.scopeForm.sort}).then(res=>{
          if (res.code === 200){
            this.searchSet()
          }
        })
      },

      //选择TREE
      showTreeWorker(id, pid) {
          this.params.status = id;
          this.getTableData();
      },

      // 打开添加
      handleOpenAdd() {
        this.addDrawer = true;
      },
      // 关闭添加/修改
      handleClose() {
        this.$confirm("确认关闭？")
          .then((_) => {
            this.addDrawer = false;
            this.editDrawer = false;
          })
          .catch((_) => {});
      },

      editTable(id){
        this.editID = id
        this.editDrawer = true
      },
      // 添加/修改成功
      handleDrawerSuccess() {
        this.handleClose();
        this.searchSet()
        this.$refs.newForm.$refs.form.resetFields();
      },
      // 清空子组件
      clearContent() {
        this.$refs.newForm.$refs.form.resetFields();
      },
      // 分页
      prevpage() {
        this.params.page -= 1;
        this.getTableData();
      },
      nextpage() {
        this.params.page += 1;
        this.getTableData();
      },
      handleCurrentChange(val) {
        this.params.page = val;
        this.getTableData();
      },
    },
    mounted() {
      this.admin_permission = this.$store.state.permission.permissionArr[page_name]
      this.getTableData();
      getProvince().then(res=>{
        if(res.code === 200){
          this.provinceList = res.data
        }
      })
    }
  };
</script>

<style scoped lang="scss">
  @import "@/static/default";

  .container {
    width: 100%;
    min-height: 100%;
    background-color: #fff !important;
    padding: 20px 32px;
    padding-bottom:0;
    display: inline-flex;

    .table {
      margin-top: 24px !important;
    }

    .toolbar {
      background: #fff;
      width: 100%;
      padding: 16px 32px 26px 0;
    }
  }

  .control-box{
    width: 100%;
    display:flex;
    flex-wrap: wrap;
    &-input{
      width: 150px;
    }
  }
  .el-main {
    padding: 0;
  }

  .demo-table-expand {
    font-size: 0;
  }

  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }

  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
  }
</style>
<style>
  .custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding: 10px 0;
    padding-right: 8px;
  }
  .el-tree-node__expand-icon.is-leaf{
    color: #c0c4cc;
  }
</style>
